import { useEffect, useState } from 'react';
import { PLAYER_KEY } from '../consts/consts';
import { onAuthStateChange, signInAnonymously } from '../services/auth';

export function useAuthLifecycle(setPlayerId: (id: string) => void) {
    const [authLoading, setAuthLoading] = useState(true);
    const [authError, setAuthError] = useState<string | null>(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChange((authState) => {
            setAuthLoading(authState.loading);
            setAuthError(authState.error);

            if (authState.user) {
                setPlayerId(authState.user.uid);
                localStorage.setItem(PLAYER_KEY, authState.user.uid);
            } else if (!authState.loading && !authState.error) {
                setAuthLoading(true);
                signInAnonymously()
                    .catch(console.error)
                    .finally(() => setAuthLoading(false));
            }
        });

        return unsubscribe;
    }, [setPlayerId]);

    return { authLoading, authError };
}
